const Types = {
  IA_PREVIEW: '@artificial-intelligence/IA_PREVIEW',
  IA_PREVIEW_SUCCESS: '@artificial-intelligence/IA_PREVIEW_SUCCESS',
  IA_PREVIEW_CLEAR: '@artificial-intelligence/IA_PREVIEW_CLEAR',
};

export default Types;
